export const DEFAULT_CURRENCY_ID = 1;
export const DEFAULT_PRICE_FIELDS = {
  broadcast: "",
  length: '',
  price: '',
};
export const PROJECT_TYPE = 'brand_detection';

export default {
  DEFAULT_CURRENCY_ID,
  DEFAULT_PRICE_FIELDS,
  PROJECT_TYPE,
};
